import { SHOW_SOLUTION } from '../types';
export const showSolution = _ref => {
  let {
    exerciseId
  } = _ref;
  return {
    exerciseId,
    type: SHOW_SOLUTION
  };
};